import { useSelector } from 'react-redux';
export var CP_PERMISSION_KEYS = {
    DASHBOARD: 'CUSTOMER_PORTAL:DASHBOARD',
    ASSOCIATE_ACCOUNT: 'CUSTOMER_PORTAL:USER_MANAGMENT:ASSOCIATE_ACCOUNT',
    EDIT_USER: 'CUSTOMER_PORTAL:USER_MANAGMENT:EDIT_USER',
    VIEW_DETAILS: 'CUSTOMER_PORTAL:USER_MANAGMENT:VIEW_DETAILS',
    IMPERSONATE: 'CUSTOMER_PORTAL:USER_MANAGMENT:IMPERSONATION',
    DEACTIVATE_USER: 'CUSTOMER_PORTAL:USER_MANAGMENT:DEACTIVATE_USER',
    REGISTRATION_MGMT: 'CUSTOMER_PORTAL:USER_MANAGMENT:REGISTRATION_MGMT',
    PAYMENT_EXPORT: 'CUSTOMER_PORTAL:PAYMENT_MANAGMENT:EXPORT',
    PAYMENT_LIST: 'CUSTOMER_PORTAL:PAYMENT_MANAGMENT:LIST',
    DOCUMENT_TYPE_ACCESS: 'CUSTOMER_PORTAL:DOCUMENT_MGMT:TYPE_ACCESS',
    DOCUMENT_SIZE: 'CUSTOMER_PORTAL:DOCUMENT_MGMT:DOC_SIZE',
    SUPPORT_LIST: 'CUSTOMER_PORTAL:SUPPORT_MANAGMENT',
    BRAND_CUSTOMIZATION: 'CUSTOMER_PORTAL:BRAND_CUSTOMIZATION:SETUP',
    FAQS: 'CUSTOMER_PORTAL:BRAND_CUSTOMIZATION:FAQ',
    CHATBOT_FAQS: 'CUSTOMER_PORTAL:BRAND_CUSTOMIZATION:CHATBOT_FAQS',
};
var checkAccess = function (rolePermissions, key, grantIfMissing) {
    if (grantIfMissing === void 0) { grantIfMissing = true; }
    var entry = rolePermissions.find(function (p) { return p.PermissionKey === key; });
    if (!entry) {
        return {
            canView: grantIfMissing,
            canCreate: grantIfMissing,
            canEdit: grantIfMissing,
            canDelete: grantIfMissing,
        };
    }
    return {
        canView: Number(entry.View) === 1,
        canCreate: Number(entry.Add) === 1,
        canEdit: Number(entry.Update) === 1,
        canDelete: Number(entry.Delete) === 1,
    };
};
var useCustomerPortalPermissions = function () {
    var rolePermissions = useSelector(function (store) { var _a, _b; return (_b = (_a = store.User.userData) === null || _a === void 0 ? void 0 : _a.RolePermissions) !== null && _b !== void 0 ? _b : []; });
    var check = function (key) { return checkAccess(rolePermissions, key); };
    return {
        dashboard: check(CP_PERMISSION_KEYS.DASHBOARD),
        associateAccount: check(CP_PERMISSION_KEYS.ASSOCIATE_ACCOUNT),
        editUser: check(CP_PERMISSION_KEYS.EDIT_USER),
        viewDetails: check(CP_PERMISSION_KEYS.VIEW_DETAILS),
        impersonate: check(CP_PERMISSION_KEYS.IMPERSONATE),
        deactivateUser: check(CP_PERMISSION_KEYS.DEACTIVATE_USER),
        registrationManagement: check(CP_PERMISSION_KEYS.REGISTRATION_MGMT),
        paymentExport: check(CP_PERMISSION_KEYS.PAYMENT_EXPORT),
        paymentList: check(CP_PERMISSION_KEYS.PAYMENT_LIST),
        documentTypeAccess: check(CP_PERMISSION_KEYS.DOCUMENT_TYPE_ACCESS),
        documentSize: check(CP_PERMISSION_KEYS.DOCUMENT_SIZE),
        supportList: check(CP_PERMISSION_KEYS.SUPPORT_LIST),
        brandCustomization: check(CP_PERMISSION_KEYS.BRAND_CUSTOMIZATION),
        faqs: check(CP_PERMISSION_KEYS.FAQS),
        chatbotFaqs: checkAccess(rolePermissions, CP_PERMISSION_KEYS.CHATBOT_FAQS, false),
        check: check,
    };
};
export default useCustomerPortalPermissions;
